import { useMutation, useQuery } from "@apollo/client";
import { Box, Button, Flex, Text } from "rebass/styled-components";
import { GET_FORM_CONTENT, GET_MY_FORMS_LIST } from "../../../graphql/queries";
import { IHealthCoachFMyHealthCoachFormsListOutputFrm, IGetFormContentOutput, IGetFormContentInput, IHealthCoachFMyHealthCoachFormsListOutputTarget, IGetMyHealthCoachFormsListInput, IGetMyHealthCoachFormsListOutput } from "../../../graphql/types/queries/forms";
import PleaseWait from "../../../components/PleaseWait";
import { useNavigate } from "react-router-dom";
import { IUser } from "../../../graphql/types/queries/user";
import { IAddHealthCoachFormToLibraryInput, IAddHealthCoachFormToLibraryOutput } from "../../../graphql/types/mutations/forms";
import { ADD_HEALTH_COACH_FORM_TO_LIBRARY } from "../../../graphql/mutations";
import { useState } from "react";
import { toast } from "react-toastify";
import { Form, Formik } from "formik";
import FormField from "../../../components/FormField";
import TextInput from "../../../components/TextInput";

export const EditModalOthers = ({ form, session, targetId, onClose }: { form: IHealthCoachFMyHealthCoachFormsListOutputFrm; session: IUser; targetId: string, onClose: () => void }) => {
  const navigate = useNavigate();
  const [isEnterDetails, setIsEnterDetails] = useState(false)
  const [preLoadData, setPreLoadData] = useState<null | {
    target: IHealthCoachFMyHealthCoachFormsListOutputTarget,
    mine: IHealthCoachFMyHealthCoachFormsListOutputFrm[]
  }>(null)
  const [addToMyLibrary, { loading: loadingAddToMyLibrary }] = useMutation<IAddHealthCoachFormToLibraryOutput, IAddHealthCoachFormToLibraryInput>(ADD_HEALTH_COACH_FORM_TO_LIBRARY,
    {
      refetchQueries: [{ query: GET_MY_FORMS_LIST }],
      awaitRefetchQueries: true,
      onCompleted: (e) => {
        if (e && e.addHealthCoachFormToLibrary && e.addHealthCoachFormToLibrary.ok) {
          toast.success('Form added to your library', { autoClose: 5000 })
          onClose()
        } else {
          toast.error('An error occured', { autoClose: 5000 })
        }
      },
      onError: () => {
        toast.error('An error occured', { autoClose: 5000 })
      }
    })
  const { data: dataFormContent, loading: loadingFormContent, error: errorFormContent } = useQuery<IGetFormContentOutput, IGetFormContentInput>(GET_FORM_CONTENT, {
    variables: {
      formId: form.id
    },
  });
  const { data, loading, error, refetch } = useQuery<IGetMyHealthCoachFormsListOutput, IGetMyHealthCoachFormsListInput>(GET_MY_FORMS_LIST, {
    onCompleted: (e) => {
      const target = e.getMyHealthCoachFormsList.find(x => x.target.id === targetId)
      if (!target) {
        toast.error('An error occured', {
          autoClose: 5000
        })
        return
      }
      const mine = target.mine
      setPreLoadData({
        target: target.target,
        mine
      })
    }
  })
  console.log({ preLoadData, form })
  return (
    <>
      <Text fontSize={'20px'} mb={4} textAlign={'center'} fontWeight={600}>{form.name}</Text>
      {!!loadingFormContent || !!loading || !preLoadData ? (
        <PleaseWait />
      ) : (
        <>
          {!isEnterDetails ? (
            <>
              <Button disabled={preLoadData.mine.filter(x => x.formId === form.id).length > 0} variant={'pink'} mb={4} width='auto' alignSelf={'center'} onClick={() => {
                setIsEnterDetails(true)
              }}>{preLoadData.mine.filter(x => x.formId === form.id).length > 0 ? 'Already in your library' : 'Add To My Library'}</Button>
              <Flex style={{ position: 'relative', alignItems: 'center' }}>
                <Flex flex={1} height={1} backgroundColor={'rgb(52, 79, 121)'} style={{ opacity: '0.3' }} width={'100%'} />
                <Box style={{ padding: '0 24px', fontWeight: 600 }}>OR</Box>
                <Flex flex={1} height={1} backgroundColor={'rgb(52, 79, 121)'} style={{ opacity: '0.3' }} width={'100%'} />
              </Flex>
              <Button variant={'outline'} mt={4} mb={4} width='auto' alignSelf={'center'} onClick={() => {
                navigate(`/form-builder?dup_${form.id}`);
              }}>Duplicate *</Button>
              <Text>* Duplication allows to create a new form with all the current content of an existing one so you can customize it. Any edits the original owner makes to its form won't be repercuted on your duplicata</Text>
            </>
          ) : (
            <Formik
              initialValues={{
                isActive: !!preLoadData.target.multipleAllowed || (preLoadData.mine && preLoadData.mine.filter(x => x.isActive === true).length < 1),
                isFavorite: false
              }}
              onSubmit={(values) => {
                console.log('SUB')
                // return
                addToMyLibrary({
                  variables: { formId: form.id, isActive: values.isActive, isFavorite: values.isFavorite },
                });
              }}

            >
              {({ touched, errors, isValid, values }) => {
                console.log({ values })
                return (
                  <>
                    <Form>
                      <Text mt={2} mb={3} textAlign={'center'}>Add {form.createdBy.firstName}'s form to your own library of forms and mark it as</Text>
                      <FormField flexDirection='row' mb={3} error={touched.isActive && errors.isActive}>
                        <TextInput type="checkbox" checked={values.isActive} id={`isActive`} name="isActive" />
                        <label htmlFor="isActive" style={{ marginLeft: '16px' }}>
                          Active
                        </label>
                      </FormField>
                      {!!values.isActive && (
                        <FormField flexDirection='row' mb={4} error={touched.isFavorite && errors.isFavorite}>
                          <TextInput type="checkbox" checked={values.isFavorite} id={`isFavorite`} name="isFavorite" />
                          <label htmlFor="isFavorite" style={{ marginLeft: '16px' }}>
                            Favorite
                          </label>
                        </FormField>
                      )}
                      {!!values.isActive && !preLoadData.target.multipleAllowed && preLoadData.mine && preLoadData.mine.filter(x => {
                        return x.isActive === true
                      }).length > 0 && (
                          <>
                            <Text>This target allows only 1 active form per user. Any other of your forms in this target will be deactivated and unfavorited:</Text>
                            {preLoadData.mine.filter(x => x.isActive === true).map(x => {
                              return (
                                <Text key={x.id}>- {x.name}</Text>
                              )
                            })}
                          </>
                        )}
                      <Flex alignItems="center" flexDirection="column">
                        <Button disabled={!isValid || loadingAddToMyLibrary} variant="primary" width={1 / 2} type="submit" id="btn_login">
                          Add
                        </Button>
                      </Flex>
                    </Form>

                  </>
                );
              }}
            </Formik>
          )}
        </>
      )}

    </>
  );
};
